<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name">{{ label }}</label>
    <input
      type="number"
      v-model.number="inputValue"
      class="rounded border px-5 py-3"
      :name="name"
      :id="name"
      :placeholder="placeholder"
      @input="debouncedEmit"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import _debounce from 'lodash.debounce';
import { useFilterStore } from '@/store/filterStore.js';

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  placeholder: { type: String, default: '' },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },
});

const filterStore = useFilterStore();
const inputValue = ref(null);

const emitValue = () => {
  filterStore.updateFilter({
    type: 'text',
    property: props.property,
    value: inputValue.value,
  });
  filterStore.fetchDynamicCount();
};

const debouncedEmit = _debounce(emitValue, 400);
</script>

<style scoped></style>
